<template>
  <div class="news-list-container">
    <div class="content">
      <el-table :data="blacklist.items" border stripe>
        <el-table-column
          v-for="col in columns"
          :key="col.id"
          :prop="col.id"
          :label="col.label"
          :width="col.width"
          :formatter="col.formatter"
        ></el-table-column>
        <el-table-column label="badge logo">
          <template slot-scope="scope">
            <img :src="scope.row.badge_logo" width="80" />
          </template>
        </el-table-column>
        <el-table-column label="发行人">
          <template slot-scope="scope">
            <span>{{ scope.row.issuer_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发行人头像">
          <template slot-scope="scope">
            <img :src="scope.row.issuer_avatar" width="80" />
          </template>
        </el-table-column>
        <el-table-column label="是否展示" width="300" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="onSubmit(scope.row.badge_code, scope.row.display)"
              v-model="scope.row.display"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="是否加入精选资产" width="300" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="
                onChangeRecommandBadges(
                  scope.row.badge_code,
                  scope.row.is_recommand
                )
              "
              v-model="scope.row.is_recommand"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="是否提示风险" width="300" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="postRisk(scope.row.badge_code, scope.row.is_risk)"
              v-model="scope.row.is_risk"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="currentPage"
        :page-sizes="[30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="blacklist.count"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/configs/index";
import {
  fetchBadgeList,
  postBadgeDisplay,
  postRecommand,
  deleteRecommand,
  postRisk,
} from "@/api/badge";

// const BADGE_URL = "https://api.ddpurse.com/v1/phoenix/get_badge_list";
// const BADGE_CONFIG_URL = "https://api.ddpurse.com/v1/phoenix_admin/config_badge_by_badge_code";

// const BADGE_SET_RECOMMAND_URL = "https://api.ddpurse.com/v1/phoenix_admin/set_recommand_badges";

// const BADGE_DELETE_RECOMMAND_URL =
//   "https://api.ddpurse.com/v1/phoenix_admin/delete_recommand_badges";

export default {
  data() {
    return {
      blacklist: {},
      columns: [
        {
          id: "badge_name",
          label: "badge名称",
          width: 100,
          align: "center",
        },
        {
          id: "badge_name_abbreviation",
          label: "badge名称缩写",
          width: 180,
        },
      ],
      currentPage: 1,
      pageSize: 30,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    sizeChange(size) {
      this.pageSize = size;
      // this.currentPage = 1;
      this.fetchData();
    },
    currentChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    fetchData() {
      let query = {};
      query = {
        offset: (this.currentPage - 1) * this.pageSize,
        limit: this.pageSize,
        display_type: 2,
      };
      fetchBadgeList(query).then((data) => {
        console.log(data);
        if (+data.data.code === -1) {
          return;
        }
        const blacklist = data.data.data || [];
        if (blacklist) {
          this.blacklist = {
            items: blacklist.badge_infos,
            count: blacklist.count,
          };
        }
      });
    },

    onChangeRecommandBadges(tx, data) {
      if (data) {
        this.setRecommandBadges(tx);
      } else {
        this.deleteRecommandBadges(tx);
      }
    },

    setRecommandBadges(tx) {
      let query = {};
      query = {
        badge_code: tx,
      };
      postRecommand(query).then((data) => {
        console.log(data.data.msg);
      });
    },

    deleteRecommandBadges(tx) {
      let query = {};
      query = {
        badge_code: tx,
      };
      deleteRecommand(query).then((data) => {
        console.log(data.data.msg);
      });
    },
    onSubmit(tx, display) {
      let query = {};
      query = {
        badge_code: tx,
        display: display,
      };
      postBadgeDisplay(query).then((data) => {
        console.log(data.data.msg);
      });
    },

    postRisk(tx, risk) {
      let query = {};
      query = {
        badge_code: tx,
        is_risk: risk,
      };
      postRisk(query).then((data) => {
        this.fetchData();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.news-list-container {
  margin: 0;

  .header {
    margin: 20px;
  }

  .search-input {
    width: 250px;
  }

  .create-option {
    display: flex;
    justify-content: flex-end;
  }

  .content {
    padding: 0 20px 20px;
  }
}
</style>
